import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { Router } from '@angular/router';
import {
  IAppdwellingWithdrawn,
  IApplication,
  IDwelling,
  IUser
} from '@ebb-v2/ebb-integration';
import { AuthenticationService } from '../../data-services';

@Component({
  selector: 'ebb-portal-withdrawn-application-list',
  templateUrl: './withdrawn-application-list.component.html'
})
export class WithdrawnApplicationComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: IAppdwellingWithdrawn[] = [];
  // @Input() dwellingwithdrawndata: IDwelling[] = [];
  @Input() ShowWithdrawnApplications: boolean;
  @Input() toggleDisplayCardList: boolean;
   @Input() currentUser: IUser;

  @Input() toggleOpenClosedProjects: boolean;

  public cardLayout = 100 / 3 + '%';
  public tablePageSizeOptions: number[] = [10, 25, 50];
  public displayedColumns = [
    'applicationNumber',
    '_Ebb_OwnerId_Formatted',
    'name',
    'acceptedDate',
    '_Ebb_ProgramCycleId_Formatted',
    '_EBB_ProgramType',
    'displaystatus',
    'action'
  ];
  public dataSource = new MatTableDataSource<IAppdwellingWithdrawn>([]);

  public dataSourceLength = 0;
  constructor(private readonly router: Router,
    private readonly authenticationService: AuthenticationService) {}
  ngOnChanges(): void {
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  public ngOnInit() {
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
  public onClickOpenApplication(id: string): void {
    this.router.navigate(['application', id]);
  }
  public getFormattedDate(date: any): string {
    let dateObj: Date;
    if (date) {
      dateObj = new Date(date);
    } else {
      const today = new Date();
      dateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    }
    const permitDateUTC = dateObj;
    permitDateUTC.setHours(permitDateUTC.getHours() + 8);

    const permitDatePST = new Date(permitDateUTC);

    const year = permitDatePST.getFullYear();

    let month = (1 + permitDatePST.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = permitDatePST.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return `${month}/${day}/${year}`;
  }
  // 1: ALL Read-only; 2: Contractor Read-only; 3: ALL Edit
  public checkUserAuthorization(
    stateCode: number,
    contractorPerm: number
  ): number {
    const retVal = 1;
    if (stateCode === 1) {
      return 1;
    }
    if (stateCode === 0) {
      if (this.isContractor() && contractorPerm === 700000003) {
        return 2;
      }
      if (this.isContractor() && contractorPerm === 700000001) {
        return 3;
      }
      if (this.isHomeowner() && !this.isContractor()) {
        return 3;
      }
    }
    return retVal;
  }

  public programTypeDesc(programType) {
    switch (programType) {
      case 700000000:
        return 'CEA BB';
        
      case 700000001:
      case 700000002: 
        return 'EBB';
        
      case 700000003:
        return 'ESS';
        
      case 700000004:
        return 'EMR';
        
      default:
        return 'EBB';
    }
  }


  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

}
